import React from 'react';

import { useAuthContext } from 'state/auth';

import { IUpsellStrategyProps } from './types';
import { Upsell } from './upsell';
import { useMenuFeatureUpsell } from './use-menu-feature-upsell';

const MenuFeatureUpsell: React.FC<IUpsellStrategyProps> = ({ isInCart }) => {
  const upsellData = useMenuFeatureUpsell();
  return <Upsell {...upsellData} isInCart={isInCart} />;
};

export const UpsellStrategy: React.FC<IUpsellStrategyProps> = props => {
  const { isAuthenticated } = useAuthContext();
  return isAuthenticated ? <MenuFeatureUpsell {...props} /> : null;
};
